function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @private
 *
 * @class StandardCacheKey
 *
 * @classdesc
 * cache key used when there is a single standard parameter
 */
var StandardCacheKey = function () {
  function StandardCacheKey(key) {
    _classCallCheck(this, StandardCacheKey);

    this.key = this._isMultiParamKey(key) ? key : key[0];
    this.size = key.length;

    return this;
  }

  /**
   * @function _isMultiParamKey
   * @memberof StandardCacheKey
   * @instance
   *
   * @description
   * is the key passed a multiple-parameter key
   *
   * @param {Array<*>} key the key to test
   * @returns {boolean} is the key a multiple-parameter key
   */
  StandardCacheKey.prototype._isMultiParamKey = function _isMultiParamKey(key) {
    return key.length > 1;
  };

  /**
   * @function _matchesMultiple
   * @memberof StandardCacheKey
   * @instance
   *
   * @description
   * does the passed key match the key in the instance
   *
   * @param {Array<*>} key the key to test
   * @returns {boolean} does the key passed match that in the instance
   */


  StandardCacheKey.prototype._matchesMultiple = function _matchesMultiple(key) {
    if (key.length !== this.size) {
      return false;
    }

    var index = 0;

    while (index < this.size) {
      if (key[index] !== this.key[index]) {
        return false;
      }

      index++;
    }

    return true;
  };

  /**
   * @function _matchesSingle
   * @memberof StandardCacheKey
   * @instance
   *
   * @description
   * does the passed key match the key in the instance
   *
   * @param {Array<*>} key the key to test
   * @returns {boolean} does the key passed match that in the instance
   */


  StandardCacheKey.prototype._matchesSingle = function _matchesSingle(key) {
    return key[0] === this.key;
  };

  /**
   * @function matches
   * @memberof StandardCacheKey
   * @instance
   *
   * @description
   * does the passed key match the key in the instance
   *
   * @param {Array<*>} key the key to test
   * @returns {boolean} does the key passed match that in the instance
   */


  StandardCacheKey.prototype.matches = function matches(key) {
    return this._isMultiParamKey(key) ? this._matchesMultiple(key) : this._matchesSingle(key);
  };

  /**
   * @function matchesCustom
   * @memberof StandardCacheKey
   * @instance
   *
   * @description
   * does the passed key match the key in the instance based on the custom equality function passed
   *
   * @param {Array<*>} key the key to test
   * @param {function} isEqual method to compare equality of the keys
   * @returns {boolean} does the key passed match that in the instance
   */


  StandardCacheKey.prototype.matchesCustom = function matchesCustom(key, isEqual) {
    return isEqual(this._isMultiParamKey(key) ? key : key[0], this.key);
  };

  return StandardCacheKey;
}();

export default StandardCacheKey;


//////////////////
// WEBPACK FOOTER
// ./~/filtermatrix/~/moize/es/StandardCacheKey.js
// module id = 2174
// module chunks = 0